import style from "./style.module.css";
import { noop } from "lib/lodash";

interface DesignConversionProps {
  message?: string;
  linkText?: string;
  onLinkClick?: (...args: never[]) => unknown;
}

const DesignConversion = ({
  message = "Your Design has been converted to a Template. View it in your",
  linkText = "Team Templates",
  onLinkClick = noop
}: DesignConversionProps) => (
  <div>
    {message}{" "}
    <button className={style.linkButton} onClick={onLinkClick}>
      {linkText}
    </button>
    .
  </div>
);

export default DesignConversion;
